<p>
  sidebar-routing-item works!
</p>
